import React from 'react';
export function Logo({
  className = 'w-24 h-24'
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/gxY6sLXaT8ZqAf2U4LnSPw/Jirafa_estilizada.png" alt="RenuevaTE_90 Logo" className={`${className} object-contain`} data-id="element-243" />;
}